import React from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { makeStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import Divider from '@material-ui/core/Divider'

import FormWrapper from 'components/form/Wrapper'
import ResourceIconTitle from 'components/resource/IconTitle'
import FolderPathTitle from 'components/resource/FolderPathTitle'
import Loading from 'components/system/Loading'

import settings from 'settings'
import selectors from 'store/selectors'
import routerActions from 'store/modules/router'
import networkActions from 'store/modules/network'
import resourceActions from 'store/modules/resource'

const {
  resources,
} = settings

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(2),
    overflowY: 'auto',
  },
  paper: {
    padding: theme.spacing(5),
  },
  button: {
    marginRight: theme.spacing(2),
  },
  formHeader: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  formHeaderIcon: {
    marginRight: theme.spacing(),
  },
  headerDivier: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  }
}))

const nameField = {
  id: 'name',
  title: 'Name',
  default: '',
  helperText: 'Enter the resource name',
  validate: {
    type: 'string',
    methods: [
      ['required', 'Required'],
    ],
  },
}

const ResourceEdit = ({

}) => {
  const classes = useStyles()
  const dispatch = useDispatch()

  const {
    section,
    parentid,
    type,
  } = useSelector(selectors.router.params)

  const resourceSchemas = useSelector(selectors.resource.schemas)
  const schema = resourceSchemas[type]

  const folderPath = useSelector(selectors.resource.folderPath)
  const id = useSelector(selectors.router.idParam)
  const data = useSelector(selectors.resource.listCollection.item)
  const error = useSelector(selectors.resource.errors.save)
  const submitting = useSelector(selectors.resource.loading.save)
  const loading = useSelector(selectors.resource.loading.get)

  const onSave = (id, values) => dispatch(resourceActions.save(id, values))
  const onCancel = (section, parentid) => dispatch(routerActions.navigateTo('resource.list', { section, parentid }))
  const clearError = () => dispatch(networkActions.clearError('resource.save'))
  const onView = ({
    section,
    parentid,
  }) => dispatch(routerActions.navigateTo('resource.list', { section, parentid }))

  const navigateTo = (name, params) => dispatch(routerActions.navigateTo(name, params))

  const resource = resources[type]
  const useSchema = [nameField].concat(schema)

  if(!data) return <Loading />

  return (
    <div className={ classes.root }>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Paper className={ classes.paper }>
            <FolderPathTitle
              section={ section }
              folderPath={ folderPath }
              search={ '' }
              onView={ onView }
              linkAll
            />
            <Divider
              className={ classes.headerDivier }
            />
            <FormWrapper
              schema={ useSchema }
              initialValues={ data }
              error={ error }
              storeActions={{
                navigateTo,
              }}
              onSubmit={ (values) => onSave({
                section,
                parentid,
                type,
                id,
                data: values,
              }) }
              renderButtons={
                ({
                  handleSubmit,
                }) => {
                  return (
                    <React.Fragment>
                      <Button
                        className={ classes.button }
                        type="button"
                        variant="contained"
                        onClick={ () => onCancel(section, parentid) }
                      >
                        Cancel
                      </Button>
                      <Button
                        className={ classes.button }
                        type="button"
                        variant="contained"
                        color="primary"
                        disabled={ submitting }
                        onClick={ handleSubmit }
                      >
                        Save
                      </Button>
                    </React.Fragment>
                  )
                }
              }
            />
          </Paper>
        </Grid>
      </Grid>
    </div>
  )
}

export default ResourceEdit